import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ActionIcon, Table } from '@mantine/core';
import { IconGripVertical } from '@tabler/icons-react';
import { flexRender, type Row } from '@tanstack/react-table';
import type { CSSProperties } from 'react';

import type { LightAutomation } from '../../../../api';

type DraggableRowProps = {
  row: Row<LightAutomation>;
  handleClickRow: (event: React.MouseEvent, rowId: string) => void;
  handleMiddleClickRow: (event: React.MouseEvent, rowId: string) => void;
};

export const DraggableRow = ({ row, handleClickRow, handleMiddleClickRow }: DraggableRowProps) => {
  const sortableProps = useSortable({ id: row.original.id });

  return (
    <Table.Tr
      ref={sortableProps.setNodeRef}
      style={computeStyles(sortableProps)}
      onClick={event => handleClickRow(event, row.original.id)}
      onAuxClick={event => handleMiddleClickRow(event, row.original.id)}
    >
      {row.getVisibleCells().map(cell => (
        <Table.Td key={cell.id} style={{ width: cell.column.getSize() }}>
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </Table.Td>
      ))}
    </Table.Tr>
  );
};

export const RowDragHandleCell = ({ rowId }: { rowId: string }) => {
  const { attributes, listeners } = useSortable({ id: rowId });

  return (
    <ActionIcon variant="transparent" style={{ cursor: 'grab' }} {...attributes} {...listeners}>
      <IconGripVertical color="gray" size={20} stroke={1.5} />
    </ActionIcon>
  );
};

const computeStyles = ({
  transform,
  transition,
  isDragging,
}: ReturnType<typeof useSortable>): CSSProperties => ({
  transform: CSS.Transform.toString(transform),
  transition,
  opacity: isDragging ? 0.8 : 1,
  zIndex: isDragging ? 1 : 0,
  position: 'relative',
  cursor: 'pointer',
});
